import { render } from "./AdminsPage.vue?vue&type=template&id=23f5d6a5"
import script from "./AdminsPage.vue?vue&type=script&lang=js"
export * from "./AdminsPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/learnbil/public_html/learnbilly.com/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__